/**
 * Styles for the Customer Referral Dashboard Screen
 *
 * Extracted from referrals.tsx to keep files under 300 lines.
 * Task: cq-001
 */

import { StyleSheet, type ViewStyle } from 'react-native';
import type { ReferralStatus } from '../../hooks/useCustomerReferral';

export const styles = StyleSheet.create({
  center: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  scroll: {
    flex: 1,
  },
  scrollContent: {
    paddingTop: 60,
    paddingBottom: 40,
    gap: 16,
  },
  header: {
    paddingHorizontal: 20,
    marginBottom: 8,
  },
  title: {
    fontSize: 28,
    fontWeight: '800',
    color: '#18181B',
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 15,
    fontWeight: '400',
    color: '#71717A',
    lineHeight: 22,
  },
  section: {
    paddingHorizontal: 16,
  },
  generateText: {
    fontSize: 15,
    fontWeight: '400',
    color: '#52525B',
    textAlign: 'center',
    marginBottom: 16,
  },
  statsRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  stat: {
    flex: 1,
    alignItems: 'center',
    paddingVertical: 8,
  },
  statValue: {
    fontSize: 32,
    fontWeight: '800',
    color: '#7C3AED',
  },
  statLabel: {
    fontSize: 13,
    fontWeight: '500',
    color: '#71717A',
    marginTop: 4,
  },
  statDivider: {
    width: 1,
    height: 40,
    backgroundColor: '#E4E4E7',
  },
  sectionTitle: {
    fontSize: 15,
    fontWeight: '700',
    color: '#18181B',
    marginBottom: 12,
  },
  referralRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#F4F4F5',
  },
  referralInfo: {
    flex: 1,
    marginRight: 12,
  },
  referralEmail: {
    fontSize: 14,
    fontWeight: '500',
    color: '#18181B',
  },
  referralDate: {
    fontSize: 12,
    fontWeight: '400',
    color: '#A1A1AA',
    marginTop: 2,
  },
  statusBadge: {
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 12,
  },
  statusSuccess: {
    backgroundColor: '#DCFCE7',
  },
  statusActive: {
    backgroundColor: '#EDE9FE',
  },
  statusPending: {
    backgroundColor: '#F4F4F5',
  },
  statusText: {
    fontSize: 11,
    fontWeight: '600',
    color: '#52525B',
    textTransform: 'capitalize',
  },
});

export function getStatusStyle(status: ReferralStatus['status']): ViewStyle {
  switch (status) {
    case 'subscribed':
    case 'rewarded':
      return styles.statusSuccess;
    case 'signed_up':
      return styles.statusActive;
    default:
      return styles.statusPending;
  }
}
